import React from 'react'
import { Button } from 'antd'
import './styles.scss'

export default ({files, files_loading, previous_path, on_navigate_back, on_create_folder, on_refresh, on_upload }) =>{
  return <div className='navigation columnWrap'>
    <Button icon="left-circle-o" size={'large'} onClick={()=> on_navigate_back()}
            disabled={files_loading || !previous_path}>
      Back
    </Button>

    <div>
      <Button icon="folder-add" size={'small'} onClick={()=> on_create_folder()}/>
      <Button icon="sync" size={'small'} loading={files_loading} onClick={()=> on_refresh()}/>
      {
        files.filter(i => i.checked).length > 1 ?
        <Button icon="upload" size={'small'}  onClick={()=> on_upload()}/> : null
      }
    </div>
  </div>
}
